import React from 'react';
import { Link, Route, Switch, useHistory, useParams } from 'react-router-dom';

// components
import { Tabs, Tab } from '@mui/material';
import { styled, makeStyles } from '@mui/styles';

import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';

const DevelopersRouter = ({ routes = [], rootPath }: any) => {
  const history = useHistory();
  // @ts-expect-error TS(2339): Property 'tab' does not exist on type '{}'.
  const { tab: currentTab, id: subView } = useParams();
  const [currentRoute] = routes.filter((route) =>
    route.path.endsWith(currentTab)
  );
  const classes = useStyles();
  const tabsStyles = useTabsStyles();
  const tabItemStyles = useTabItemStyles();
  const handleTabChange = React.useCallback(
    (e: any, nextTab: any) => {
      history.push(`/${rootPath}/developers/${nextTab}`);
    },
    [history, rootPath]
  );

  let subViewTitle;
  if (subView == 'create') {
    subViewTitle = 'Add/Edit API Access Key';
  } else if (subView === 'activity') {
    subViewTitle = 'API Activity';
  }

  return (
    <section className={classes.parentSection}>
      <Breadcrumbs style={{ marginBottom: '1.33rem' }} title="Developers">
        <p>Developers</p>
        {!subView ? (
          <p>{currentRoute.nav.name}</p>
        ) : (
          <Link to={`/${rootPath}/developers/${currentTab}`}>
            {currentRoute.nav.name}
          </Link>
        )}
        {subViewTitle ? <p>{subViewTitle}</p> : subView && <p>{subView}</p>}
      </Breadcrumbs>
      <Tabs value={currentTab} onChange={handleTabChange} classes={tabsStyles}>
        {routes
          .filter((route) => !!route.nav)
          .map((route) => (
            <Tab
              label={route.nav.name}
              value={route.path.split('/')[3]}
              classes={tabItemStyles}
            />
          ))}
      </Tabs>
      <Spacer style={{ borderTopLeftRadius: '0.3rem' }} />
      <Switch>
        {routes.map((route) => (
          <Route key={route.path} {...route} />
        ))}
      </Switch>
    </section>
  );
};

const useStyles = makeStyles(() => ({
  parentSection: {
    height: '100%',
    position: 'relative',
    overflowX: 'auto',
  },
}));

const useTabsStyles = makeStyles(({ palette }) => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  root: {
    minHeight: 'unset',
  },
  flexContainer: {
    '& > button:last-of-type': {
      borderRight: `0.5px solid ${palette.border.grey}`,
    },
  },
}));

const useTabItemStyles = makeStyles(({ palette }) => ({
  root: {
    textTransform: 'none',
    color: `${palette.primary.contrastText} !important`,
    '&:focus': {
      opacity: 1,
    },
    minWidth: '10rem',
    fontWeight: 'normal',
    height: '2rem',
    margin: 'auto 0',
    minHeight: 'unset',
    borderLeft: `0.5px solid ${palette.border.grey}`,
  },
  selected: {
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    backgroundColor: palette.background.paper,
    color: `${palette.primary.contrastText} !important`,
    height: '3rem',
    borderRight: `none !important`,
    borderLeft: `none !important`,
    '&.Mui-selected': {
      color: `${palette.primary.contrastText} !important`,
    },
    '& + button': {
      borderLeft: `none !important`,
    },
  },
}));

const Spacer = styled('div')(({ theme }) => ({
  height: '1.3rem',

  backgroundColor: theme.palette.background.paper,
  borderTopRightRadius: '0.3rem',
}));

export default DevelopersRouter;
